import { fromJS } from 'immutable';
export var SET_TRAFFIC_EVENT_MARKERS = 'traffic-dashboard/SET_TRAFFIC_EVENT_MARKERS';
export var SET_TRAFFIC_EVENT_COUNT = 'traffic-dashboard/SET_TRAFFIC_EVENT_COUNT';
export var SET_TRAFFIC_EVENT_MARKERS_SORT = 'traffic-dashboard/SET_TRAFFIC_EVENT_MARKERS_SORT';
export var SET_TRAFFIC_EVENT_TABLE_DATA = 'traffic-dashboard/SET_TRAFFIC_EVENT_TABLE_DATA';
export var SET_EVENT_TYPE_LIST = 'traffic-dashboard/SET_EVENT_TYPE_LIST';
export var SET_MAP_CENTER = 'traffic-dashboard/SET_MAP_CONTER';
export var SET_MAP_ZOOM = 'traffic-dashboard/SET_MAP_ZOOM';
export var SET_OPEN_DIALOG = 'traffic-dashboard/SET_OPEN_DIALOG';
export var SET_DIALOG_CONTENT = 'traffic-dashboard/SET_DIALOG_CONTENT';
export var SET_MAP_BOUNDS = 'traffic-dashboard/SET_MAP_BOUNDS';
export var RESET = 'traffic-dashboard/RESET';
export var setTrafficEventMarkers = function setTrafficEventMarkers(data) {
  return {
    type: SET_TRAFFIC_EVENT_MARKERS,
    data: data
  };
};
export var setTrafficEventCount = function setTrafficEventCount(data) {
  return {
    type: SET_TRAFFIC_EVENT_COUNT,
    data: data
  };
};
export var setTrafficEventMarkersSort = function setTrafficEventMarkersSort(sort) {
  return {
    type: SET_TRAFFIC_EVENT_MARKERS_SORT,
    sort: sort
  };
};
export var setTrafficEventTableData = function setTrafficEventTableData(data) {
  return {
    type: SET_TRAFFIC_EVENT_TABLE_DATA,
    data: data
  };
};
export var setEventTypeList = function setEventTypeList(data) {
  return {
    type: SET_EVENT_TYPE_LIST,
    data: data
  };
};
export var setMapCenter = function setMapCenter(data) {
  return {
    type: SET_MAP_CENTER,
    data: data
  };
};
export var setMapZoom = function setMapZoom(data) {
  return {
    type: SET_MAP_ZOOM,
    data: data
  };
};
export var setOpenDialog = function setOpenDialog(data) {
  return {
    type: SET_OPEN_DIALOG,
    data: data
  };
};
export var setDialogContent = function setDialogContent(data) {
  return {
    type: SET_DIALOG_CONTENT,
    data: data
  };
};
export var setMapBounds = function setMapBounds(data) {
  return {
    type: SET_MAP_BOUNDS,
    data: data
  };
};
export var reset = function reset() {
  return {
    type: RESET
  };
};
var initialState = fromJS({
  trafficEventMarkers: [],
  trafficEventCount: 0,
  trafficEventMarkersSort: {
    field: 'beginTime',
    desc: true
  },
  trafficEventTableData: [],
  eventTypeList: [],
  mapCenter: {},
  mapZoom: null,
  openDialog: false,
  dialogContent: {},
  mapBounds: {}
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_TRAFFIC_EVENT_MARKERS:
      return state.set('trafficEventMarkers', action.data);

    case SET_TRAFFIC_EVENT_COUNT:
      return state.set('trafficEventCount', action.data);

    case SET_TRAFFIC_EVENT_MARKERS_SORT:
      return state.set('trafficEventMarkersSort', action.sort);

    case SET_TRAFFIC_EVENT_TABLE_DATA:
      return state.set('trafficEventTableData', action.data);

    case SET_EVENT_TYPE_LIST:
      return state.set('eventTypeList', action.data);

    case SET_MAP_CENTER:
      return state.set('mapCenter', action.data);

    case SET_MAP_ZOOM:
      return state.set('mapZoom', action.data);

    case SET_OPEN_DIALOG:
      return state.set('openDialog', action.data);

    case SET_DIALOG_CONTENT:
      return state.set('dialogContent', action.data);

    case SET_MAP_BOUNDS:
      return state.set('mapBounds', action.data);

    case RESET:
      return initialState;

    default:
      return state;
  }
}